import { useEffect, useState } from 'react';
import { audioAsset } from '../lib/attractAudio';

interface IntroSequenceProps { onComplete: () => void; reducedMotion: boolean; }

export function IntroSequence({ onComplete, reducedMotion }: IntroSequenceProps) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const duration = reducedMotion ? 1200 : 4400;
    const swoosh = new Audio(audioAsset('/assets/audio/ui/logo-swoosh.wav'));
    swoosh.volume = 0.85;
    const swooshTimer = reducedMotion ? null : window.setTimeout(() => { void swoosh.play().catch(() => undefined); }, 1050);
    const leaveTimer = window.setTimeout(() => setLeaving(true), duration - 450);
    const completeTimer = window.setTimeout(onComplete, duration);
    return () => {
      if (swooshTimer !== null) window.clearTimeout(swooshTimer);
      swoosh.pause();
      swoosh.src = '';
      window.clearTimeout(leaveTimer);
      window.clearTimeout(completeTimer);
    };
  }, [onComplete, reducedMotion]);

  return (
    <section className={`intro${leaving ? ' intro--leaving' : ''}`} aria-label="The Smackers introduction">
      <div className="intro__ink" aria-hidden="true" />
      <p className="intro__presents">L34D SOFTWARE PRESENTS</p>
      <img className="intro__logo" src="/assets/references/logo_game.png" alt="The Smackers" width="981" height="369" />
      <p className="intro__subtitle">KNOW YOUR ENEMY</p>
    </section>
  );
}
